import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box, IconButton, Switch } from '@material-ui/core';
import type { Palette } from '@material-ui/core/styles/createPalette';
import DeleteIcon from '@material-ui/icons/Delete';

export const buildWhitelistColumns = ({
  deleteDomain,
  toggleDomainStatus,
  statusUpdatingId,
  palette,
  readOnly = false,
}: {
  deleteDomain: (id: string) => void;
  toggleDomainStatus: (id: string, nextActive: boolean) => void;
  statusUpdatingId?: string | null;
  palette: Palette;
  readOnly?: boolean;
}): GridColDef[] => {
  const columns: GridColDef[] = [
    {
      flex: 1,
      field: 'domain',
      headerName: 'Domain',
      disableColumnMenu: true,
      sortable: true,
      minWidth: 200,
    },
    {
      flex: 1,
      field: 'createdAt',
      headerName: 'Date Added',
      disableColumnMenu: true,
      sortable: false,
      minWidth: 200,
    },
    {
      flex: 1,
      field: 'note',
      headerName: 'Note',
      disableColumnMenu: true,
      sortable: false,
      minWidth: 200,
    },
  ];

  if (!readOnly) {
    columns.push({
      flex: 0.5,
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      disableColumnMenu: true,
      minWidth: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams) => {
        if (params.row.id === 'placeholder') {
          return <span>--</span>;
        }

        const isUpdating = statusUpdatingId === params.row.id;

        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Switch
              checked={Boolean(params.row.active)}
              onChange={(_e, checked) =>
                toggleDomainStatus(params.row.id, checked)
              }
              disabled={isUpdating}
              color="primary"
              inputProps={{
                'aria-label': params.row.active
                  ? 'Deactivate domain'
                  : 'Activate domain',
              }}
            />
            <Box ml={1}>
              <IconButton
                aria-label="delete"
                onClick={() => deleteDomain(params.row.id)}
              >
                <DeleteIcon style={{ color: palette.error.main }} />
              </IconButton>
            </Box>
          </Box>
        );
      },
    });
  }

  return columns;
};
